import { createApi } from '@reduxjs/toolkit/query/react';
import { authBaseQuery } from '../app/axiosBaseQuery';

export const gdprApi = createApi({
    reducerPath: 'gdpr',
    baseQuery: authBaseQuery(),
    endpoints: (builder) => ({
        exportMyData: builder.mutation<{ message: string; data: any }, void>({
            query() {
                return {
                    url: '/auth/gdpr/export',
                    method: 'POST',
                };
            },
        }),
        deleteMyAccount: builder.mutation<{ message: string }, void>({
            query() {
                return {
                    url: '/auth/gdpr/delete',
                    method: 'POST',
                };
            },
        }),
    }),
});

export const { useExportMyDataMutation, useDeleteMyAccountMutation } = gdprApi;
